module.exports = __webpack_public_path__ + "img/pony_free.e5a9ca25.png";